import React, { Fragment, useState, useMemo, useEffect } from 'react'
import classNames from 'classnames'
import gridClasses from '../../styles/grid.module.css'
import classes from './MyCourses.module.css'
import {
    randomBoolean,
    getNumMatches,
    randomFloat,
    getParentRoute,
} from '../../util/functions'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { Link } from 'react-router-dom'
import ToggleBar from '../../components/ToggleBar/ToggleBar'
import { ProgressSummaryCard } from '../../components/Cards/ProgressSummaryCard/ProgressSummaryCard'
import Footer from '../../components/Footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { userCoursesSelectors } from './userCoursesSlice'
import notification from '../../components/Notification/notification'
import { getUserCourses } from './userCoursesApi'
import CardLoader from '../../components/loaders/CardLoader'
import { IMG_URL } from '../../api/api'
import emptyCourseImage from '../../assets/images/empty-course.svg'
import Empty from '../../components/Empty/Empty'

const courseData = new Array(10).fill(0).map(() => ({
    image: 'https://i.picsum.photos/id/549/300/200.jpg',
    title: '12 Tips to Help You Capture Stunning Landscape Photos',
    category: 'HUMAN RESOURCES',
    progress: randomFloat(),
    wishlisted: randomBoolean(),
}))

const filters = {
    ongoing: c => Math.floor(c.progress * 101) < 100,
    completed: c => Math.floor(c.progress * 101) === 100,
    wishisted: c => c.wishisted,
}

export const MyCoursesPage = ({ location }) => {
    const [activeToggleItem, setActiveToggleItem] = useState('all')

    const dispatch = useDispatch()

    const isFetching = useSelector(userCoursesSelectors.isFetching)
    const hasError = useSelector(userCoursesSelectors.hasError)
    const errorMessage = useSelector(userCoursesSelectors.errorMessage)
    const userCourses = useSelector(userCoursesSelectors.courses)

    const toggleItems = useMemo(
        () => [
            {
                text: 'All',
                active: activeToggleItem === 'all',
                id: 'all',
            },
            {
                text: 'Ongoing',
                active: activeToggleItem === 'ongoing',
                badge: activeToggleItem === 'ongoing' && {
                    variant: 'blue',
                    text: userCourses.length,
                },
                id: 'ongoing',
            },
            {
                text: 'Completed',
                id: 'completed',
                active: activeToggleItem === 'completed',
            },
        ],
        [activeToggleItem, userCourses]
    )

    const activeCategoryId = activeToggleItem

    useEffect(() => {
        if (hasError)
            notification.failure({
                title: 'Failed to fetch your courses',
                description: errorMessage,
            })
    }, [hasError, errorMessage])

    useEffect(() => {
        dispatch(
            getUserCourses({
                queryParam:
                    activeToggleItem === 'all' ? undefined : activeToggleItem,
            })
        )
    }, [dispatch, activeToggleItem])

    const parentRoute = getParentRoute(location.pathname)

    let emptyMessage = "You haven't enrolled for any courses."

    if (activeCategoryId === 'ongoing')
        emptyMessage = 'You have no ongoing courses.'

    if (activeCategoryId === 'completed')
        emptyMessage = "You haven't completed any of your courses"

    return (
        <Fragment>
            <AuthenticatedHeader />
            <main className={classes.main}>
                <div className={classes.topLinks}>
                    <div
                        className={classNames(
                            gridClasses.container,
                            classes.topLinksContainer
                        )}
                    >
                        <Link
                            to={`${parentRoute}/my-courses`}
                            className={classNames(
                                classes.topLink,
                                classes.topLinkActive
                            )}
                        >
                            My Courses
                        </Link>
                        <Link
                            to={`${parentRoute}/my-classes`}
                            className={classes.topLink}
                        >
                            My Classes
                        </Link>
                    </div>
                </div>
                <div
                    className={classNames(
                        gridClasses.container,
                        classes.toggleBarWrapper
                    )}
                >
                    <ToggleBar
                        links={toggleItems}
                        changeActive={setActiveToggleItem}
                        activeId={activeToggleItem}
                    />
                </div>
                <div className={gridClasses.container}>
                    <div className={classes.cardsGrid}>
                        {isFetching &&
                            [1, 2, 3].map(id => <CardLoader key={id} />)}
                        {userCourses.map((course, index) => (
                            <ProgressSummaryCard
                                to={`/app/courses/${course.coursecode}/${course.classid}/lessons/${course.currentLessonId}/${course.currentTopicId}`}
                                category={course.catName}
                                title={course.title}
                                progress={
                                    course.progressDetails.percentageCompleted
                                }
                                image={
                                    course.thumbnail ||
                                    require('../../assets/images/course-placeholder.svg')
                                }
                                key={index}
                                vertical
                                className={classes.card}
                            />
                        ))}
                    </div>
                    {userCourses.length === 0 && !isFetching && (
                        <Empty icon={emptyCourseImage} text={emptyMessage} />
                    )}
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}
